import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  max-width: 1300px;
  margin: 0 auto;
  padding: 8px;

  h1 {
    color: #fff;
    font-size: 40px;
    margin: 8px;
    letter-spacing: 2px;
    margin-bottom: 16px;
    z-index: 1;
  }

  a.more {
      position: relative;
      display: block;
      width: 220px;
      text-align: center;
      padding: 8px;
      margin: 16px 8px 8px;
      color: #007fff;
      font-size: 16px;
      font-weight: 700;
      overflow: hidden;
      transition: 0.2s;
      letter-spacing: 2px;
      background-color: transparent;
      border: 1px solid #007fff;
    }

    a.more:hover {
      background: #007fff;
      color: #fff;
      box-shadow: 0 0 8px #007fff;
    }

`;

export const Cards = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  flex-wrap: wrap;
  height: auto;

  @media(max-width: 767px) {
  grid-template-columns: 1fr;
  }
`;
